import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportConsolidated } from './Consolidated.services';

export function useQuestReportConsolidated() {
  return useMutation(getQuestReportConsolidated, {
    onSuccess() {
      notification.success({
        message: 'O relatório de estoque consolidado foi gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
